<section class="split">
  <div class="account">
    <capra-icon
      class="icon"
      icon="illo-google"
    ></capra-icon>
    <div>
      <h3 class="email">
        {{ email }}
      </h3>
      <p class="copy">
        <span>
          Connected by: {{ connectedBy ? (connectedBy) : '--' }}
        </span>
        <span class="last-upload">
          Last upload: {{ lastUploadedAt ? (lastUploadedAt | date) : '--' }}
        </span>
      </p>
    </div>
  </div>
</section>
